
export default {
    loading(state){
        return state.loading
    },
    loadingEmpty(state){
        return state.loadingEmpty
    },

    list(state){
        return state.list
    },

    empty(state){
        return state.empty
    }
}